import { getCart } from '@/js/api/cart.ts';
import { getClient } from '@/js/api/client.ts';
import { getDeliveryData, getLiftData, getPickupData } from '@/js/api/order.ts';
import { SPINNER_CLASS } from '@/js/cart.ts';
import AppCheckout from '@/js/vue/checkout/app-checkout.vue';
import { createApp } from 'vue';

const CHECKOUT_SELECTOR = '.vue-checkout';
const checkoutElement = document.querySelector(CHECKOUT_SELECTOR);

export async function initCheckout() {
  if (!checkoutElement)
    return;
  try {
    const deliveryData = await getDeliveryData();
    const liftData = await getLiftData();
    const client = await getClient();
    const { data } = await getCart();
    const pickup = await getPickupData();
    const app = createApp(AppCheckout, {
      deliveryPricing: deliveryData.data,
      client: client.data,
      liftPricing: liftData.data,
      cart: data,
      pickupPrice: pickup.data?.price ?? 0,
    });
    app.mount(checkoutElement);
    checkoutElement.classList.remove(SPINNER_CLASS);
  }
  catch (e) {
    console.log(e);
  }
}
